import { get, put } from '@/api/request';

function fetchVersions(params) {
  return get('/versions', params);
}

function fetchSingleVersion({ id, params = {} }) {
  return get(`/versions/${id}`, params);
}

function revertVersion(id) {
  return put(`/versions/${id}/revert`);
}

export default {
  fetchVersions,
  fetchSingleVersion,
  revertVersion,
};



// WEBPACK FOOTER //
// ./src/store/modules/version/api.js